
import { defineComponent, ref } from "vue";
import store from "@/store";
export default defineComponent({
  name: "index",
  setup() {
    return {};
  },
});
